<template>
  <v-container fluid fill-height class="auth-container py-0">
    <v-layout :align-center="$vuetify.breakpoint.smAndUp" justify-center row>
      <v-flex xs12 sm8 md6 lg4 xl3>
        <v-card :class="$vuetify.breakpoint.smAndUp ? 'elevation-12 transparent_area' : 'elevation-0'" :tile="!$vuetify.breakpoint.smAndUp">
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'elevation-12' : 'elevation-0'" :tile="!$vuetify.breakpoint.smAndUp">
            <v-img height="30vh" :src="require('@/assets/img/amexLogo.jpg')" />
            <v-card-text>
              <router-view />
            </v-card-text>
          </v-card>
          <v-card-subtitle class="px-0 py-3">
            <v-layout style="color: white">
              <span>{{ $t("view.home.footer.sistema") }}</span>
              <v-spacer />
              <span style="font-size: 11px"><strong>&copy;</strong> {{ $t("view.home.footer.copyRight") }}</span>
            </v-layout>
          </v-card-subtitle>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<!-- Implementation Script -->
<script>
export default { name: "AuthenticationModule" };
</script>
<!-- Style scoped Implementation -->
<style scoped>
.transparent_area {
  padding: 15px 15px 0px 15px;
  background: radial-gradient(ellipse at center, hsla(0, 0%, 89.8%, 0.65) 0, hsla(0, 0%, 41.2%, 0) 100%) !important;
}

/* Media Query for small devices */
@media (min-width: 601px) {
  .auth-container:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    display: block;
    width: 100%;
    background-image: url("~@/assets/img/amex.jpg");
    background-size: cover;
    filter: blur(4px);
    background-position: center;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/Authentication.vue